import api from "../api";

const guardianEmailService = {
  // Get guardian statuses for dropdown
  getGuardianStatuses: async () => {
    try {
      console.log("🔍 [SERVICE] Fetching guardian statuses");
      const response = await api.get("/guardians/emails/status/create");
      console.log("📊 [SERVICE] Guardian statuses response:", response);
      return response;
    } catch (error) {
      console.error("❌ [SERVICE] Error fetching guardian statuses:", error);
      throw error;
    }
  },

  // Send email to guardians of specific status
  sendEmailToGuardiansOfStatus: async (formData) => {
    try {
      console.log("🚀 [SERVICE] Sending email to guardians of status");
      const response = await api.post("/guardians/emails/status/store", formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
      console.log("✅ [SERVICE] Email sent successfully:", response);
      return response;
    } catch (error) {
      console.error("❌ [SERVICE] Error sending email:", error);
      throw error;
    }
  },
};

export default guardianEmailService; 